var _excluded = ["show", "context", "closeModal", "onContinue"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Modal, ModalBody } from "reactstrap";
import EmptySearch from "../../../../assets/images/illustrations/empty_search.png";
import { Button } from "../../../../core/components";
import React from "react";
var NoMatchModal = function NoMatchModal(_ref) {
  var show = _ref.show,
    context = _ref.context,
    closeModal = _ref.closeModal,
    onContinue = _ref.onContinue,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var handleContinue = function handleContinue() {
    return onContinue();
  };
  return /*#__PURE__*/React.createElement(Modal, Object.assign({
    isOpen: show,
    zIndex: 21800000000
  }, otherProps), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", {
    className: "p-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center border-bottom mb-4 pb-3"
  }, "Curriculum Reference Missing"), /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-4"
  }, /*#__PURE__*/React.createElement("img", {
    width: 400,
    src: EmptySearch,
    className: "img-fluid"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, "We could not find any references in your curriculum boundary document that are related to your request. Would you like to continue anyway and generate ", context === 'assessment' ? 'an assessment' : 'the rubrics', " without linking it to your curriculum?"), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "me-2 text-primary",
    color: "transparent",
    onClick: function onClick() {
      return closeModal();
    }
  }, "Try again"), /*#__PURE__*/React.createElement(Button, {
    withLoader: true,
    onClick: handleContinue
  }, "Continue")))));
};
NoMatchModal.defaultProps = {
  context: 'assessment'
};
export default NoMatchModal;